import React, { useState, useEffect } from "react";
import { Card, Row, Col, Typography } from "antd";
// On importe les catégories depuis le JSON
import MyLoader from "../composant/MyLoader";
import menuData from "../data/data.json"; 

const { Title, Text } = Typography;
const { Meta } = Card;

const MenuConsultation = () => {
  /* ===== TEXTE ANIMÉ DU HEADER ===== */
  const texts = [
    "Découvrez nos plats savoureux",
    "Une expérience culinaire unique",
    "Le goût de l'authenticité"
  ];
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % texts.length);
        setFade(true);
      }, 300);
    }, 3000);
    return () => clearInterval(interval);
  }, [texts.length]);

    useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  /* ===== LOADER ===== */
  if (loading) {
    return <MyLoader />;
  }

  return (
    <>
      <style>{`
        html, body { margin: 0; background: #f9f9f9; font-family: 'Segoe UI', Tahoma, sans-serif; overflow-x: hidden; }
        .container { max-width: 1200px; margin: 0 auto; padding: 10px 12px; }
        .sticky-header { position: sticky; top: 0; z-index: 999; background: #fff; border-bottom: 1px solid #eee; box-shadow: 0 2px 8px rgba(0,0,0,0.05); }
        .header-flex { display: flex; align-items: center; justify-content: space-between; padding: 10px 0; }
        .logo { height: 50px; object-fit: contain; }
        .category-title { margin-top: 30px !important; margin-bottom: 20px !important; border-left: 4px solid #edbb05; padding-left: 15px; }
        .product-img { height: 180px; width: 100%; object-fit: cover; background: #eee; border-radius: 8px 8px 0 0; }
        .product-card { border-radius: 8px; overflow: hidden; transition: transform 0.2s; }
        .product-card:hover { transform: translateY(-5px); }
      `}</style>

      {/* ===== HEADER ===== */}
      <div className="sticky-header">
        <div className="container header-flex">
          <img src="/logo.png" alt="logo" className="logo" />
          <div style={{ textAlign: 'center', flex: 1 }}>
            <Title level={4} style={{ margin: 0 }}>RESTO SADEM</Title>
            <Text type="secondary" style={{ fontSize: 12, color: "#edbb05", transition: "opacity 0.3s", opacity: fade ? 1 : 0 }}>
              {texts[index]}
            </Text>
          </div>
          <div style={{ width: 50 }} />
        </div>
      </div>

      {/* ===== LISTE DES PRODUITS PAR CATÉGORIES ===== */}
      <div className="container">
        {menuData.map((categoryData, idx) => (
          <div key={idx}>
            <Title level={3} className="category-title">
              {categoryData.category}
            </Title>
            
            <Row gutter={[16, 24]}>
              {categoryData.items.map((product, pIdx) => (
                <Col xs={12} sm={12} md={8} lg={6} key={`${idx}-${pIdx}`}>
                  <Card
                    hoverable
                    className="product-card"
                    bordered={false}
                    cover={
                      <img
                        src={product.image || "/image.png"}
                        alt={product.name}
                        loading="lazy"
                        className="product-img"
                      />
                    }
                  >
                    <Meta
                      title={<div style={{whiteSpace: 'normal', fontSize: 15 }}>{product.name}</div>}
                     description={
                      <Text strong style={{ color: '#edbb05', fontSize: 15 }}>
                        {String(product.price).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} FCFA
                      </Text>
                    }
                                        
                    />
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        ))}
      </div>

      {/* Footer simple pour finir la page */}
      <div style={{ textAlign: 'center', padding: '40px 0', color: '#888' }}>
        <Text italic>Bon appétit chez RESTO SADEM</Text>
      </div>
    </>
  );
};

export default MenuConsultation;